import truncate from "lodash/truncate";
import stripHtml from "./stripHtml";

const _ = { truncate };

export default function schemaDescription(review, poiType) {
  const plainTextReview = stripHtml(review);

  if (poiType === "eating") {
    return _.truncate(plainTextReview, {
      length: 200,
      omission: "…",
    });
  }

  return plainTextReview;
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schemaDescription.js